import { useAuthActions } from "@convex-dev/auth/react";

import { NotificationStatus } from "@/components/Notifications/NotificationStatus";
import { Button } from "@/components/ui/button";

export const Account = () => {
  const { signOut } = useAuthActions();
  return (
    <div className="flex flex-col gap-8">
      <section>
        <h2 className="text-lg font-semibold mb-2">Account</h2>
        <div>
          <Button variant="outline" onClick={signOut}>
            Sign out
          </Button>
        </div>
      </section>

      <NotificationStatus />
    </div>
  );
};
